import React, { useState } from "react";
import { Input, Uploader } from "rsuite";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { FileType } from "rsuite/esm/Uploader";
import { PageHeader } from "../../SharedComponents/PageHeader";
import * as uploadDb from "../../Services/FileUploadsDB";
import * as userManager from "../../Services/UserSessionManager";

export const QualityUpload = () => {

    const pkt_url = uploadDb.PktUrl();
    const quality_url=uploadDb.QualityUrl();
    const [checkRole,setCheckRole]=useState(userManager.GetUserRole());

    const attendance_url=uploadDb.AttendanceUrl();
    return <>
        <div>
            <PageHeader title="Quality Upload" backPage="" ><></></PageHeader>
            <hr />
            <div className="d-flex flex-row justify-content-start gap-3">

         
              
              {checkRole=='QM'||checkRole=='A'?
                <div className="card   w-auto h-auto mt-2" >
                    <Uploader action={quality_url} onSuccess={(response: string, file: FileType) =>{ if(response==="Success")toast.success('Uploaded Successfully.');else toast.error('Failed !')}} onProgress={(percent: number, file: FileType)=>toast.warning('Uploading...'+percent)} draggable>
                        <div style={{lineHeight:'auto'}}>Click or Drag files to this area to upload</div>
                    </Uploader>
                    <div className="card-body">
                        <h5 className="card-title">Quality Upload</h5>
                        <div className="d-flex flex-column">
                            <a href='/Quality_template.xlsx' download >Download Quality Template</a>
                        </div>
                    </div>
                </div>:<></>}       
                     </div>
        </div>
    </>
}